import {omit} from 'lodash';

import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {VacationResponderModel} from '../../../models/api/vacationResponderModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {VacationResponderActionsEnum} from './vacationRespondersActions';

/*
 * Reducer.
 */

const vacationRespondersUpdatedReducer = createResourcesUpdatedReducer(
  'vacationResponders',
  (vacationResponder) => vacationResponder.id,
);

export function vacationRespondersReducer(
  state: ResourceMap<VacationResponderModel>,
  action: AppAction,
): ResourceMap<VacationResponderModel> {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED:
      return vacationRespondersUpdatedReducer(state, action);

    case VacationResponderActionsEnum.VACATION_RESPONDER_DELETED:
      return omit(state, action.payload);

    default:
      return state;
  }
}
